export { AttachSchoolRequest } from './attach-school-request';
export { SchoolCollectionRequest } from './school-collection-request';
export { CreateSchoolRequest } from './create-school-request';
export { UpdateSchoolRequest } from './update-school-request';

export type { AttachSchoolFormValues } from './attach-school-request';
export type { CreateSchoolFormValues } from './create-school-request';
export type { UpdateSchoolFormValues } from './update-school-request';
